import { SpinResponse } from '@cgs/data-access';
import { Container, SceneObject } from '@cgs/wge';

import {
  ComponentNames,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  ISlotGameEngineProvider,
  ReelsEngine,
  T_ISlotGameEngineProvider,
} from '@cgs/machines';
import { NodeUtils } from '@cgs/shared';

const DEFAULT_POSITIONS = [0, 1, 2, 3, 4];

export const SLOT_ICONS_MASK_COMPONENT_TOKEN = Symbol('SLOT_ICONS_MASK_COMPONENT_TOKEN');

export class SlotIconsMaskComponent {
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly _reelsEngine: ReelsEngine;

  constructor(container: Container, positions: number[] = DEFAULT_POSITIONS) {
    this._gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this._reelsEngine =
      container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;

    this._gameStateMachine.accelerate.entered.listen(() => {
      positions.forEach((position) =>
        this._reelsEngine.iconAnimationHelper.getEntities(position).forEach((entity) => {
          const iconNodeScene = entity.get<SceneObject>(
            this._reelsEngine.entityEngine.getComponentIndex(ComponentNames.IconNode)
          );
          iconNodeScene && NodeUtils.addMask(iconNodeScene);
        })
      );
    });

    this._gameStateMachine.stop.entered.listen(() => {
      positions.forEach((position) =>
        this._reelsEngine.iconAnimationHelper.getEntities(position).forEach((entity) => {
          const iconNodeScene = entity.get<SceneObject>(
            this._reelsEngine.entityEngine.getComponentIndex(ComponentNames.IconNode)
          );
          iconNodeScene && NodeUtils.removeMask(iconNodeScene);
        })
      );
    });
  }
}
